import script from "./CheckoutFormData.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutFormData.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutFormData.vue?vue&type=style&index=0&id=b5db6dbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5db6dbc"]])

export default __exports__